const axios = require('axios').default;

export async function getAllTagsDictionary() {
  let res = await axios.get("https://api.aitos.no/dictionary/alltags");
  return res.data;
}